import axios from 'axios';
import { takeLatest, takeEvery, put, call } from 'redux-saga/effects';
import _ from 'lodash';
import { getSkillsetOfTypeSuccess } from './actions/skillset';
import { isStatusOk } from '../utilities/helpers';
import { getNextNofificationStatus } from '../components/NotificationSettingsContainer';
import {
  GET_SKILLSET_OPTIONS_OF_TYPE,
  UPDATE_NOTIFICATION_SETTINGS,
  UPDATE_BUSINESS_ATTRIBUTES,
  UPDATE_USER_PROFILE,
} from './actions/actionTypes';
import {
  setUserProfileCustomAttribute,
  updateBusinessAttributesSuccess,
  updateBusinessAttributesFailure,
  updateUserProfileSuccess,
  updateUserProfileFailure,
} from './actions/userProfile';
import {
  updateNotificationSettingsSuccess,
  updateNotificationSettingsFailure,
} from './actions/settings';
import { apiCallSuccess, apiCallFailed } from './actions/notification';
import { createActivity, updateUserBusiness } from './apis';
import {
  GET_SKILLSET_OPTIONS_API,
  API_KEY_ACCOUNTS,
  UPDATE_USER_PROFILE_API,
  API_SUCCESS_MESSAGES,
  UPLOAD_API,
  API_KEY_JOBS,
} from '../constants';
export function* getSkillsetOptionsSaga(action) {
  try {
    const response = yield axios({
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': API_KEY_ACCOUNTS,
      },
      url: `${GET_SKILLSET_OPTIONS_API}/${action.skillsetType}`,
    });

    if (isStatusOk(response)) {
      yield put(getSkillsetOfTypeSuccess(action.skillsetType, response.data));
    } else {
      //   yield put(
      //     // addNotification(
      //     //   'Failed to get skillset options. Please try again later.',
      //     //   NOTIFICATON_LEVELS.ERROR,
      //     // ),
      //   );
      yield put(apiCallSuccess());
    }
  } catch (err) {
    // LogRocket.captureException(err, {
    //   source: 'getSkillsetOptionsSaga',
    //   message: 'Failed to get skillset options.',
    // });
    yield put(apiCallFailed());
  }
}
export function* updateBusinessAttributesSaga(action) {
  try {
    console.log('Incoming', action);
    // map to builder detail request
    let skillset = [];
    if (action.businessAttributes.businessSkillsetBuild) {
      const skillsetBuildList = action.businessAttributes.businessSkillsetBuild
        .split(' & ')
        .map(skillsetBuildItem => ({
          type: 'build',
          name: skillsetBuildItem,
        }));
      skillset = skillset.concat(skillsetBuildList);
    }
    if (action.businessAttributes.businessSkillsetLook) {
      const skillsetLookList = action.businessAttributes.businessSkillsetLook
        .split(' & ')
        .map(skillsetLookItem => ({
          type: 'look',
          name: skillsetLookItem,
        }));
      skillset = skillset.concat(skillsetLookList);
    }

    let mailingAddress = null;
    if (action.businessAttributes.businessMailingAddress) {
      mailingAddress = {
        fullAddress: action.businessAttributes.businessMailingAddress,
      };
    }

    let serviceArea = null;
    if (action.businessAttributes.businessServiceAreaType) {
      const [latitudeStr, longitudeStr] = action.businessAttributes
        .businessServiceAreaCoordinates
        ? action.businessAttributes.businessServiceAreaCoordinates.split(',')
        : [];
      const latitude = latitudeStr ? parseFloat(latitudeStr) : null;
      const longitude = longitudeStr ? parseFloat(longitudeStr) : null;
      serviceArea = {
        type: action.businessAttributes.businessServiceAreaType,
        fullAddress: action.businessAttributes.businessServiceAreaAddress,
        latitude,
        longitude,
        state: action.businessAttributes.businessServiceAreaState,
      };
    }

    // uploading images
    let logo = _.get(action.businessAttributes, 'logoImage.id');
    if (_.get(action, 'businessAttributes.logo') === 'removed') {
      logo = null;
    } else if (
      action.businessAttributes.logo &&
      action.businessAttributes.logo.length
    ) {
      // checking if new image is set
      const file = action.businessAttributes.logo[0];
      const res = yield uploadImage(file, file.name, 'logo');
      logo = `${res.fileId}`;
    }

    let coverPhoto = _.get(action.businessAttributes, 'coverPhotoImage.id');
    console.log('coverPhoto', coverPhoto);
    console.log('coverPhoto - logo', logo);
    if (_.get(action, 'businessAttributes.coverPhoto') === 'removed') {
      coverPhoto = null;
    } else if (
      action.businessAttributes.coverPhoto &&
      action.businessAttributes.coverPhoto.length
    ) {
      // checking if new image is set
      const file = action.businessAttributes.coverPhoto[0];
      const res = yield uploadImage(file, file.name, 'cover');
      coverPhoto = `${res.fileId}`;
    }
    // // eslint-disable-next-line prefer-destructuring
    // file = data.attributes.coverPhoto[0];
    // res = yield uploadImage(file, file.name, 'cover');
    // data.attributes['custom:coverPhoto'] = `${res.fileId}`;
    // delete data.attributes.coverPhoto;

    const galleryIds = [];
    const galleryImages = _.get(action.businessAttributes, 'galleryImages', []);
    console.log({ galleryImages }, 'galleryImages');
    if (galleryImages) {
      for (let i = 0; i < galleryImages.length; i += 1) {
        const image = galleryImages[i];
        if (image.file) {
          const res = yield uploadImage(
            image.file[0],
            image.file[0].name,
            'gallery',
          );
          if (res.fileId) galleryIds.push(res.fileId);
        } else {
          galleryIds.push(image.id);
        }
      }
    }

    const gallery = galleryIds.join(',');
    // return;
    console.log('above updated');

    const businessDetails = {
      businessNumber: action.businessAttributes.businessNumber,
      name: action.businessAttributes.businessName,
      description: action.businessAttributes.businessDescription,
      position: action.businessAttributes.businessPosition,
      mailingAddress,
      serviceArea,
      skillset,
      materialLocation: action.businessAttributes.materialLocation,
      logo,
      coverPhoto,
      gallery,
      googlePlaceField: action.businessAttributes.googlePlaceField,
      googlePlaceId: action.businessAttributes.googlePlaceId,
    };
    console.log('updated', businessDetails);
    // previous builders
    let prevMailingAddress = null;
    let PrevServiceArea = null;
    let prevSkillset = [];
    let prevLogo = _.get(action.previousBusinessAttributes, 'logoImage.id');
    let prevCoverPhoto = _.get(
      action.previousBusinessAttributes,
      'coverPhotoImage.id',
    );

    let previousBusinessDetails = null;

    let testBusinessDetails = null;
    let changedValues = null;

    if (action.previousBusinessAttributes) {
      console.log('inside previousBusinessAttributes');
      if (action.previousBusinessAttributes.businessMailingAddress) {
        prevMailingAddress = {
          fullAddress: action.previousBusinessAttributes.businessMailingAddress,
        };
      }

      if (action.previousBusinessAttributes.businessServiceAreaType) {
        const [latitudeStr, longitudeStr] = action.previousBusinessAttributes
          .businessServiceAreaCoordinates
          ? action.previousBusinessAttributes.businessServiceAreaCoordinates.split(
              ',',
            )
          : [];
        const latitude = latitudeStr ? parseFloat(latitudeStr) : null;
        const longitude = longitudeStr ? parseFloat(longitudeStr) : null;
        PrevServiceArea = {
          type: action.previousBusinessAttributes.businessServiceAreaType,
          fullAddress:
            action.previousBusinessAttributes.businessServiceAreaAddress,
          latitude,
          longitude,
          state: action.previousBusinessAttributes.businessServiceAreaState,
        };
      }

      if (action.previousBusinessAttributes.businessSkillsetBuild) {
        const skillsetBuildList = action.previousBusinessAttributes.businessSkillsetBuild
          .split(' & ')
          .map(skillsetBuildItem => ({
            type: 'build',
            name: skillsetBuildItem,
          }));
        prevSkillset = prevSkillset.concat(skillsetBuildList);
      }
      if (action.previousBusinessAttributes.businessSkillsetLook) {
        const skillsetLookList = action.previousBusinessAttributes.businessSkillsetLook
          .split(' & ')
          .map(skillsetLookItem => ({
            type: 'look',
            name: skillsetLookItem,
          }));
        prevSkillset = prevSkillset.concat(skillsetLookList);
      }

      if (_.get(action, 'previousBusinessAttributes.logo') === 'removed') {
        prevLogo = null;
      } else if (
        action.previousBusinessAttributes.logoImage
        // &&
        // action.previousBusinessAttributes.logoImage.length
      ) {
        prevLogo = action.previousBusinessAttributes.logoImage.id;
      }

      if (
        _.get(action, 'previousBusinessAttributes.coverPhotoImage') ===
        'removed'
      ) {
        prevCoverPhoto = null;
      } else if (
        action.previousBusinessAttributes.coverPhotoImage
        // &&
        // action.businessAttributes.coverPhoto.length
      ) {
        prevCoverPhoto = action.previousBusinessAttributes.coverPhotoImage.id;
      }
      previousBusinessDetails = {
        businessNumber: action.previousBusinessAttributes.businessNumber,
        name: action.previousBusinessAttributes.businessName,
        description: action.previousBusinessAttributes.businessDescription,
        position: action.previousBusinessAttributes.businessPosition,
        materialLocation: action.previousBusinessAttributes.materialLocation,
        mailingAddress: prevMailingAddress,
        serviceArea: PrevServiceArea,
        skillset: prevSkillset,
        logo: prevLogo,
        coverPhoto: prevCoverPhoto,
        gallery: action.previousBusinessAttributes.galleryImages,
        googlePlaceField: action.previousBusinessAttributes.googlePlaceField,
        googlePlaceId: action.previousBusinessAttributes.googlePlaceId,
      };

      testBusinessDetails = {
        ...businessDetails,
        gallery: businessDetails.gallery.split(','),
      };

      changedValues =
        previousBusinessDetails &&
        Object.keys(testBusinessDetails).filter(
          k => testBusinessDetails[k] !== previousBusinessDetails[k],
        );
    }
    console.log({
      testBusinessDetails,
      previousBusinessDetails,
      changedValues,
    });

    if (changedValues && changedValues.length >= 1) {
      for (let i = 0; i < changedValues.length; i += 1) {
        console.log('let i = 0; i < changedValues.length; i += 1');
        if (changedValues[i] === 'name') {
          yield call(
            createActivity,
            action.accessToken,
            businessDetails.businessNumber,
            localStorage.getItem('username'),
            'Business Name Updated',
          );
        } else if (changedValues[i] === 'description') {
          yield call(
            createActivity,
            action.accessToken,
            businessDetails.businessNumber,
            localStorage.getItem('username'),
            'Profile Description Updated',
          );
        } else if (changedValues[i] === 'position') {
          yield call(
            createActivity,
            action.accessToken,
            businessDetails.businessNumber,
            localStorage.getItem('username'),
            'Position Updated',
          );
        } else if (changedValues[i] === 'materialLocation') {
          yield call(
            createActivity,
            action.accessToken,
            businessDetails.businessNumber,
            localStorage.getItem('username'),
            'Material Location Updated',
          );
        } else if (changedValues[i] === 'mailingAddress') {
          if (
            testBusinessDetails.mailingAddress.fullAddress !==
            previousBusinessDetails.mailingAddress.fullAddress
          ) {
            yield call(
              createActivity,
              action.accessToken,
              businessDetails.businessNumber,
              localStorage.getItem('username'),
              'Business Mailing Address Updated',
            );
          }
        } else if (changedValues[i] === 'coverPhoto') {
          yield call(
            createActivity,
            action.accessToken,
            businessDetails.businessNumber,
            localStorage.getItem('username'),
            'Cover Photo Updated',
          );
        } else if (changedValues[i] === 'logo') {
          yield call(
            createActivity,
            action.accessToken,
            businessDetails.businessNumber,
            localStorage.getItem('username'),
            'Profile Image Updated',
          );
        } else if (changedValues[i] === 'gallery') {
          if (action.profileType !== 'service_area') {
            if (
              testBusinessDetails.gallery.length !==
              previousBusinessDetails.gallery.length
            ) {
              yield call(
                createActivity,
                action.accessToken,
                businessDetails.businessNumber,
                localStorage.getItem('username'),
                'Gallery Images Updated',
              );
            }
          }
        } else if (changedValues[i] === 'skillset') {
          if (
            testBusinessDetails.skillset.length !==
            previousBusinessDetails.skillset.length
          ) {
            yield call(
              createActivity,
              action.accessToken,
              businessDetails.businessNumber,
              localStorage.getItem('username'),
              'Skillset Updated',
            );
          }
        } else if (changedValues[i] === 'serviceArea') {
          if (action.profileType === 'service_area') {
            const changedServiceAreaValues = Object.keys(
              testBusinessDetails.serviceArea,
            ).filter(
              k =>
                testBusinessDetails.serviceArea[k] !==
                previousBusinessDetails.serviceArea[k],
            );
            console.log('changedServiceAreaValues', changedServiceAreaValues);
            if (
              changedServiceAreaValues &&
              changedServiceAreaValues.length >= 1
            ) {
              yield call(
                createActivity,
                action.accessToken,
                businessDetails.businessNumber,
                localStorage.getItem('username'),
                'Service Area Updated',
              );
            }
          }
        }
      }
    }

    // console.log('came to last');
    // return;
    const response = yield call(
      updateUserBusiness,
      action.accessToken,
      businessDetails.businessNumber,
      businessDetails,
    );

    if (isStatusOk(response)) {
      yield put(updateBusinessAttributesSuccess(action.profileType));
      yield put(apiCallSuccess(API_SUCCESS_MESSAGES.BUSINESS_UPDATED));
    } else {
      yield put(apiCallFailed());
    }
  } catch (err) {
    yield put(updateBusinessAttributesFailure(action.profileType));
    yield put(apiCallSuccess());
  }
}

export function* updateNotificationSettingsSaga(action) {
  const userAttributes = {
    [action.customAttributeKey]: action.value,
  };
  // console.warn('Value', { userAttributes, action });
  const { businessNumber } = action;
  // return;
  try {
    const response = yield call(
      updateUserProfile,
      action.accessToken,
      businessNumber,
      userAttributes,
    );

    if (isStatusOk(response)) {
      yield call(
        createActivity,
        action.accessToken,
        businessNumber,
        localStorage.getItem('username'),
        `${
          action.notificationType === 'email' ? 'Email' : 'Sms'
        } Notification ${action.value}`,
      );

      yield put(updateNotificationSettingsSuccess(action.notificationType));
      yield put(apiCallSuccess('Settings updated successfully'));
    } else {
      yield put(updateNotificationSettingsFailure(action.notificationType));
      yield put(
        setUserProfileCustomAttribute(
          action.customAttributeKey,
          getNextNofificationStatus(action.value),
        ),
      );
      yield put(apiCallFailed());
    }
  } catch (err) {
    yield put(updateNotificationSettingsFailure(action.notificationType));
    yield put(
      setUserProfileCustomAttribute(
        action.customAttributeKey,
        getNextNofificationStatus(action.value),
      ),
    );
    yield put(apiCallFailed());
  }
}

export function* updateUserProfile(
  accessToken,
  businessNumber,
  userAttributes,
) {
  const response = yield axios({
    method: 'put',
    data: {
      ...userAttributes,
    },
    url: `${UPDATE_USER_PROFILE_API}/${businessNumber}`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
      'x-api-key': API_KEY_ACCOUNTS,
    },
  });
  return response;
}

export function* updateUserProfileSaga(action) {
  console.log('Action', action);
  const changedValues = Object.keys(action.userAttributes).filter(
    k => action.userAttributes[k] !== action.previousBusinessAttributes[k],
  );
  // return;
  const { businessNumber } = action;
  try {
    const response = yield call(
      updateUserProfile,
      action.accessToken,
      businessNumber,
      action.userAttributes,
    );

    if (isStatusOk(response)) {
      if (changedValues.length >= 1) {
        for (let i = 0; i < changedValues.length; i += 1) {
          if (changedValues[i] === 'custom:businessYears') {
            yield call(
              createActivity,
              action.accessToken,
              businessNumber,
              localStorage.getItem('username'),
              'Number Of Years Business Has Been Open Updated',
            );
          } else if (changedValues[i] === 'custom:employeesCount') {
            yield call(
              createActivity,
              action.accessToken,
              businessNumber,
              localStorage.getItem('username'),
              'Number Of Permanent Employees Updated',
            );
          } else if (changedValues[i] === 'custom:newBuildsPerYear') {
            yield call(
              createActivity,
              action.accessToken,
              businessNumber,
              localStorage.getItem('username'),
              'New Builds Completed Over The Past Year Updated',
            );
          } else if (changedValues[i] === 'custom:renovationsPerYear') {
            yield call(
              createActivity,
              action.accessToken,
              businessNumber,
              localStorage.getItem('username'),
              'Renovations Completed Over The Past Year Updated',
            );
          }
        }
      }
      console.log('Status OK');
      if (action.businessAttributes) {
        yield call(
          updateUserBusiness,
          action.accessToken,
          action.businessAttributes.businessNumber,
          action.businessAttributes,
        );
      }

      yield put(updateUserProfileSuccess(action.profileType));
      yield put(apiCallSuccess('User profile has been successfully updated.'));
    } else {
      yield put(apiCallFailed('Something is wrong. Please try again later.'));
    }
  } catch (err) {
    yield put(updateUserProfileFailure(action.profileType));
    yield put(apiCallFailed('Something is wrong. Please try again later.'));
  }
}

function* updateBusinessAttributesWatcher() {
  yield takeLatest(UPDATE_BUSINESS_ATTRIBUTES, updateBusinessAttributesSaga);
}

function* getSkillsetOptionsWatcher() {
  yield takeEvery(GET_SKILLSET_OPTIONS_OF_TYPE, getSkillsetOptionsSaga);
}

function* updateNotificationSettingsWatcher() {
  yield takeEvery(UPDATE_NOTIFICATION_SETTINGS, updateNotificationSettingsSaga);
}

function* updateUserProfileWatcher() {
  yield takeLatest(UPDATE_USER_PROFILE, updateUserProfileSaga);
}

function* uploadImage(file, fileName, type) {
  try {
    console.log('UploadImage');
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', fileName);
    formData.append('type', type);
    const response = yield axios({
      method: 'post',
      url: UPLOAD_API,
      headers: {
        'x-api-key': API_KEY_JOBS,
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
    });
    return response.data;
  } catch (err) {
    return {};
  }
}

export {
  getSkillsetOptionsWatcher,
  updateBusinessAttributesWatcher,
  updateNotificationSettingsWatcher,
  updateUserProfileWatcher,
};
